import React, { useEffect, createElement } from 'react';
export function ConsultationPage() {
  useEffect(() => {
    // Load the Typeform embed script
    const script = document.createElement('script');
    script.src = '//embed.typeform.com/next/embed.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      // Clean up script when component unmounts
      document.body.removeChild(script);
    };
  }, []);
  return <div className="min-h-screen w-full bg-gray-900" data-id="element-85">
      {/* Header section */}
      <div className="w-full bg-gray-900 py-12 px-4 sm:px-6 sm:py-16 lg:px-8" data-id="element-86">
        <div className="max-w-3xl mx-auto text-center" data-id="element-87">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-white tracking-tight mb-6 leading-tight uppercase" data-id="element-88">
            READY TO ESCAPE THE{' '}
            <span className="text-[#8AE234] underline underline-offset-2" data-id="element-89">
              "COPYWRITER GURU TRAP"
            </span>
            ?
          </h1>
          <p className="text-base sm:text-lg md:text-xl font-medium text-gray-300 mb-4" data-id="element-90">
            Book your free strategy session with the guy who learned the
            business of freelance directly from the BEST in the game.
          </p>
          <p className="text-sm sm:text-base text-gray-300 mb-4" data-id="element-91">
            I'll show you the exact strategies that took me from homeless to
            $23K months... and why most copywriters never make this leap.
          </p>
        </div>
      </div>
      {/* Typeform section */}
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-16" data-id="element-92">
        <div className="bg-gray-900 rounded-lg shadow-lg overflow-hidden border border-gray-800" data-id="element-93">
          <div className="p-6" data-id="element-94">
            <h2 className="text-2xl font-bold text-white mb-6 text-center" data-id="element-95">
              Step 1: Complete the form below (est: 45 seconds)
            </h2>
            <div data-tf-live="01K500G5S1XRCX6A2ZNTCYSS89" className="min-h-[500px]" data-id="element-96"></div>
            <p className="text-sm text-gray-400 mt-4 text-center italic" data-id="element-97">
              Step 2: You'll be able to book your call time at the end
            </p>
          </div>
        </div>
      </div>
    </div>;
}